import { createContext } from 'react'

export interface AuthUser {
  sub: string
  email: string
  given_name?: string
  family_name?: string
  [key: string]: any
}

export interface AuthContextValue {
  user: AuthUser | null | undefined
  signOut?: (() => void) | undefined
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  signOut: undefined
})

export const AuthProvider = AuthContext.Provider
